// import React from "react";
import { Grid, Box, Typography, Divider, Paper } from "@mui/material";
// import { twoData } from "./landingPageConstant"; // Your data source
// import { twoData } from "../landingpage/landingPageConstant";
import { domain } from "../../constants/generalConstant";
import contact from "../../assets/contactus.jpg";
import anyloc from "../../assets/anyloc.jpg";

export default function ContactUi() {
  const twoData = [
    {
      title: "Get in touch anytime",
      subTitle: "For all Shippers",
      description: `
			
			
			Contact us easily via phone, email, or live chat. For urgent shipments or personalized service, our support team is ready to help. We look forward to serving you with professionalism and care.
			
			 `,
      imgUrl: contact,
      serviceLink: "",
      serviceLinkTitle: `Global Shipment Updates and Support`,
      id: 1,
      subData: [
        {
          title: "Flexible Import/Export Options",
          // icon: <MdOutlineImportExport />,
          id: 1,
        },
        {
          title: "Tailored Business Solutions",
          // icon: <IoBusiness />,
          id: 2,
        },
        {
          title: "Next Possible Business Day",
          // icon: <RiFlightTakeoffLine />,
          id: 3,
        },
        {
          title: "Wide Variety of Optional Services",
          // icon: <CgOptions />,
          id: 4,
        },
      ],
    },
    {
      title: "Global Shipment Updates and Support",
      subTitle: "For all Shippers",

      description: `
			
			
			
			We can communicate with you about your shipment anywhere in the world, ensuring you stay updated every step of the way.
			
			`,
      imgUrl: anyloc,
      serviceLink: "",
      serviceLinkTitle: `Explore ${domain} Global Forwarding`,
      id: 2,
      subData: [
        {
          title: "Ocean Freight",
          // icon: <GiCargoShip />,
          id: 1,
        },
        {
          title: "Road Freight",
          // icon: <FaTruckFast />,
          id: 2,
        },
        {
          title: "Rail Freight",
          // icon: <MdOutlineDirectionsRailway />,
          id: 3,
        },
        {
          title: "Air Freight",
          // icon: <RiFlightTakeoffLine />,
          id: 4,
        },
      ],
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        width: "90%",
        mx: "auto",
        my: { xs: 4, lg: 8 },
        mb: 4,
      }}
    >
      {/* Section Header */}
      <Box mb={4} textAlign="center">
        <Typography variant="h4" component="h2" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Reach out to us for inquiries, support, or feedback
        </Typography>
        <Typography
          variant="subtitle1"
          color="red"
          sx={{ color: "red", textDecoration: "underline" }}
        >
          support@shippersroute.com
        </Typography>
      </Box>

      {/* Content */}
      <Grid container spacing={4} alignItems="center" sx={{}}>
        {twoData.map((data, index) => (
          <Grid
            item
            key={data.id}
            xs={12}
            md={6}
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                md: index % 2 === 0 ? "row" : "row-reverse",
              },
              alignItems: "center",
              justifyContent: "center",

              mx: "auto",
              gap: "1rem",
            }}
          >
            {/* Image */}
            <Box
              component="img"
              src={data.imgUrl}
              alt={data.title}
              sx={{
                width: { xs: "100%", md: "45%" },
                height: "auto",
                borderRadius: 2,
                mb: { xs: 2, md: 0 },
              }}
            />

            {/* Text Content */}
            <Paper
              elevation={3}
              sx={{
                p: 3,
                maxWidth: 500,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                {data.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {data.subTitle}
              </Typography>
              <Divider sx={{ my: 1, width: "20%", alignSelf: "center" }} />
              <Typography variant="body1">{data.description}</Typography>

              {/* Optional: Add contact details or actions here */}
              {/* Example: */}
              {/* <Button variant="contained" color="primary" href={data.contactLink}>Contact Us</Button> */}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
